export default [
  {
    path: '/app/services',
    name: 'Services',
    component: () => import('@/views/Services/Index.vue'),
    meta: {
      pageTitle: 'Hizmetler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'SERVICES_LIST',
      action: 'read',
      packageLimit: {
        subject: 'SERVICES',
        limit: 1,
      },
    },
  },
  {
    path: '/app/services/archive',
    name: 'ServicesArchive',
    component: () => import('@/views/Services/Archive.vue'),
    meta: {
      navActiveLink: 'Services',
      archived: true,
      pageTitle: 'Hizmetler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/services',
          active: false,
        },
        {
          text: 'Arşiv',
          active: true,
        },
      ],
      resource: 'SERVICES_ARCHIVE',
      action: 'read',
      packageLimit: {
        subject: 'SERVICES',
        limit: 1,
      },
    },
  },
  {
    path: '/app/services/add',
    name: 'ServiceAdd',
    component: () => import('@/views/Services/Add.vue'),
    meta: {
      navActiveLink: 'Services',
      pageTitle: 'Hizmetler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/services',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'SERVICES_ADD',
      action: 'read',
      packageLimit: {
        subject: 'SERVICES_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/services/edit/:id',
    name: 'ServiceEdit',
    component: () => import('@/views/Services/Edit.vue'),
    meta: {
      navActiveLink: 'Services',
      pageTitle: 'Hizmetler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/services',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'SERVICES_EDIT',
      action: 'read',
      packageLimit: {
        subject: 'SERVICES_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/services/view/:id',
    name: 'ServiceView',
    component: () => import('@/views/Services/View.vue'),
    meta: {
      navActiveLink: 'Services',
      pageTitle: 'Hizmetler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/services',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'SERVICES_VIEW',
      action: 'read',
      packageLimit: {
        subject: 'SERVICES_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/services/edit/:id/prices/add',
    name: 'ServicePricesAdd',
    component: () => import('@/views/Services/Prices/Add.vue'),
    meta: {
      navActiveLink: 'Services',
      pageTitle: 'Hizmet Fiyatları',
      breadcrumb: [
        {
          text: 'Hizmetler',
          to: '/app/services',
          active: false,
        },
        {
          text: 'Fiyat Ekle',
          active: true,
        },
      ],
      resource: 'SERVICE_PRICES_ADD',
      action: 'read',
      packageLimit: {
        subject: 'SERVICES_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/services/edit/:id/prices/edit/:id_service_prices',
    name: 'ServicePricesEdit',
    component: () => import('@/views/Services/Prices/Edit.vue'),
    meta: {
      navActiveLink: 'Services',
      pageTitle: 'Hizmet Fiyatları',
      breadcrumb: [
        {
          text: 'Hizmetler',
          to: '/app/services',
          active: false,
        },
        {
          text: 'Fiyat Güncelle',
          active: true,
        },
      ],
      resource: 'SERVICE_PRICES_EDIT',
      action: 'read',
      packageLimit: {
        subject: 'SERVICES_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/services/edit/:id/files/add',
    name: 'ServiceFilesAdd',
    component: () => import('@/views/Services/Files/Add.vue'),
    meta: {
      navActiveLink: 'Services',
      pageTitle: 'Hizmet Dosyaları',
      breadcrumb: [
        {
          text: 'Hizmetler',
          to: '/app/services',
          active: false,
        },
        {
          text: 'Dosya Ekle',
          active: true,
        },
      ],
      resource: 'SERVICE_FILES_ADD',
      action: 'read',
      packageLimit: {
        subject: 'SERVICES_MANAGE',
        limit: 1,
      },
    },
  },
  {
    path: '/app/services/edit/:id/files/add-secret',
    name: 'ServiceFilesAdd',
    component: () => import('@/views/Services/Files/AddSecret.vue'),
    meta: {
      navActiveLink: 'Services',
      pageTitle: 'Hizmet Dosyaları',
      breadcrumb: [
        {
          text: 'Hizmetler',
          to: '/app/services',
          active: false,
        },
        {
          text: 'Dosya Ekle',
          active: true,
        },
      ],
      resource: 'SERVICE_FILES_ADD_SECRET',
      action: 'read',
      packageLimit: {
        subject: 'SERVICES_SECRET_FILES',
        limit: 1,
      },
    },
  },
  {
    path: '/app/services/edit/:id/files/edit/:id_service_files',
    name: 'ServiceFilesEdit',
    component: () => import('@/views/Services/Files/Edit.vue'),
    meta: {
      navActiveLink: 'Services',
      pageTitle: 'Hizmet Dosyaları',
      breadcrumb: [
        {
          text: 'Hizmetler',
          to: '/app/services',
          active: false,
        },
        {
          text: 'Dosya Güncelle',
          active: true,
        },
      ],
      resource: 'SERVICE_FILES_EDIT',
      action: 'read',
      packageLimit: {
        subject: 'SERVICES_MANAGE',
        limit: 1,
      },
    },
  },
]
